import React, { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    telefone: "",
    mensagem: "",
    origem: "Visão Positiva",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://jacquesgomes.com.br/inspecoesapi/contato/store", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert("Formulário enviado com sucesso!");
        setFormData({
          nome: "",
          email: "",
          telefone: "",
          mensagem: "",
          origem: "Visão Positiva",
        });
      } else {
        alert("Erro ao enviar o formulário. Tente novamente.");
      }
    } catch (error) {
      console.error("Erro ao enviar o formulário:", error);
      alert("Erro ao enviar o formulário. Tente novamente.");
    }
  };

  return (
    <section id="faleconosco" className="container my-5 p-4 shadow-lg rounded bg-light">
      <h2 className="text-center mb-4 text-primary">Fale Conosco</h2>
      <p className="text-center text-muted">
        Entre em contato para dúvidas, sugestões ou informações. Responderemos o mais breve possível.
      </p>
      <form className="p-3" onSubmit={handleSubmit}>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            id="nome"
            name="nome"
            placeholder="Seu nome"
            value={formData.nome}
            onChange={handleChange}
            required
          />
          <label htmlFor="nome">Nome</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            placeholder="Seu email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <label htmlFor="email">Email</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="tel"
            className="form-control"
            id="telefone"
            name="telefone"
            placeholder="Seu telefone"
            value={formData.telefone}
            onChange={handleChange}
          />
          <label htmlFor="telefone">Telefone</label>
        </div>
        <div className="form-floating mb-3">
          <textarea
            className="form-control"
            id="mensagem"
            name="mensagem"
            placeholder="Sua mensagem"
            style={{ height: "150px" }}
            value={formData.mensagem}
            onChange={handleChange}
            required
          ></textarea>
          <label htmlFor="mensagem">Mensagem</label>
        </div>
        <button type="submit" className="btn btn-primary w-100 fw-bold">
          Enviar
        </button>
      </form>
    </section>
  );
}

export default Contact;
